"use client";
import React from 'react';

interface ContentItem {
  ctaText: string;
  description: string;
  media?: any;
  link: string;
  color?: string;
}

const ContentCard = ({ ctaText, description, media, link, color, index }: ContentItem & { index: number }) => {
  const isMediaPresent = media && media.data && media.data.attributes && media.data.attributes.url;
  return (
    <div className={`rounded-3xl p-5 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col ${isMediaPresent ? 'justify-between min-h-80 ' : ''}   align-center `} style={{ backgroundColor: color ? color : '#f8fafc' }}>
      {/* Icon Section */}
      {isMediaPresent && <div className="mb-6">
        <img
          src={media.data.attributes.url}
          alt={media.data.attributes.name}
          className="max-h-full max-w-full object-contain"
        />
      </div>}

      {/* Title Section */}
      <div className="ml-4 mb-6">
        <p className=" text-xl text-[#032D60] font-bold leading-relaxed">
          {description}
        </p>
      </div>

      {/* CTA Section */}
      <div className="ml-4 mt-auto">
        <a
          href={link}
          className="inline-flex items-center text-slate-700 text-xl font-semibold hover:text-slate-900 transition-colors duration-200"
        >
          {ctaText}
          <svg
            className="ml-2 w-6 h-6 z-[1]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />

          </svg>
          <svg className="ml-[-15px] w-6 h-6" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="50" stroke="white" strokeWidth={4} fill="white" />
          </svg>
        </a>
      </div>
    </div>
  );
};

interface HeroProps {
  data?: {
    caseStudy?: {
      id: string;
      title: string;
      description: string;
      url: string;
      media: any;
      text: string;
      colour?: string;
    }[];
  };
}

const CaseStudyWrapper = ({ data }: HeroProps) => {
  // Add safety checks and default values
  if (!data || !data.caseStudy || !Array.isArray(data.caseStudy)) {
    return null;
  }

  const content = data.caseStudy;

  return (
    <div
      className="py-20 px-6"
    >
        <div className="max-w-6xl mx-auto">

          {/* Cards Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {content.map((item, index) => (
              <ContentCard
                key={item.id}
                ctaText={item.text}
                description={item.description}
                link={item.url}
                media={item.media}
                index={index}
                color={item.colour}
              />
            ))}
          </div>
        </div>
    </div>
  );
};

export default CaseStudyWrapper;